export default __webpack_public_path__ + "static/media/video.af6f522a.mp4";